<mat-card class="charity-selector-card">
  <mat-card-header>
    <mat-card-title>Select Charity</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-filterable-dropdown
      [optionsSetter]="charityOptions"
      placeholder="Search for a charity..."
      (selectionChange)="onCharitySelected($event)">
    </app-filterable-dropdown>
  </mat-card-content>
</mat-card>

@if (charityBalance) {
  <mat-card class="balance-card">
    <mat-card-header>
      <mat-card-title>Charity Balance Summary</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="balance-item">
        <span class="balance-label">Total Contributions:</span>
        <span class="balance-value">{{ charityBalance.TotalContributions | formatCurrency }}</span>
      </div>
      <div class="balance-item">
        <span class="balance-label">Total Payouts:</span>
        <span class="balance-value">{{ charityBalance.TotalPayouts | formatCurrency }}</span>
      </div>
      <div class="balance-item amount-owed-item">
        <span class="balance-label">Amount Owed:</span>
        <span class="balance-value amount-owed">{{ charityBalance.AmountOwed | formatCurrency }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}

@if ((charityPayouts$ | async)?.length ?? 0 > 0) {
  <mat-card class="summary-card">
    <mat-card-header>
      <mat-card-title>Payout Summary</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="summary-item">
        <span class="summary-label">Total Payouts:</span>
        <span class="summary-value">{{ (charityPayouts$ | async)?.length }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Total Payout Amount:</span>
        <span class="summary-value total-amount">{{ totalPayoutAmount | formatCurrency }}</span>
      </div>
    </mat-card-content>
  </mat-card>

  <ag-grid-angular
    class="ag-theme-quartz"
    rowClass="payout-row clickable-row"
    [tooltipShowDelay]=0
    domLayout='autoHeight'
    data-testid="payout-table"
    [loading]="uiState == UIStateEnum.ShowLoading"
    overlayNoRowsTemplate="<span>No payouts for this charity</span>"
    (gridReady)="onPayoutsGridReady($event)"
    (rowClicked)="onRowClicked($event)"
    [rowData]="charityPayouts$ | async"
    [columnDefs]="payoutColDefs">
  </ag-grid-angular>
}

@if ((charityPayouts$ | async)?.length === 0 && uiState === UIStateEnum.ShowData && charityOptions.length > 0) {
  <mat-card class="no-data-card">
    <mat-card-content>
      <p>Please select a charity to view its payouts.</p>
    </mat-card-content>
  </mat-card>
}
@if (uiState === uiStateForTemplate.ShowLoading) {
  <app-loading-card-content></app-loading-card-content>
}
